import { addDoc, collection } from "firebase/firestore";
import { getFirestoreDB } from "@/firebase";
import { TestUserLog } from "./localStorageWrapper";

type Events = "createAccount" | "login" | "search" | "saveStudy" | "contactStudy" | "exitSurvey" | "enrollStudy";

function logTestData(event: Events) {
    let testUserLogString = TestUserLog.get();
    if (testUserLogString === null) {
        testUserLogString = "{}";
    }
    const testUserLog = JSON.parse(testUserLogString);
    testUserLog[event] = Date.now();

    TestUserLog.set(JSON.stringify(testUserLog));
}

/**
 * Track test user activity for reference
 */
async function logToCollection(uid: string, event: Events, details?: unknown) {
    logTestData(event);
    const db = getFirestoreDB();
    const collectionRef = collection(db, "activityLog");
    if (details !== undefined) {
        return addDoc(collectionRef, { uid, event, details, timestamp: new Date() }).catch((error) => {
            console.error(error);
        });
    }
    return addDoc(collectionRef, { uid, event, timestamp: new Date() }).catch((error) => {
        console.error(error);
    });
}

export default logToCollection;
